import React, { ReactElement, ReactNode } from 'react'

import { LinkContext } from '../../context'
import { Link as LinkType } from '../../../types/link'
import { PRODUCTS } from '../../paths'
import * as paths from './paths'
import { ILink, SiteFooter } from './site-footer'
import { WestfieldPlusContainer } from './westfield-plus-container'
import { LeftColumnContainer } from './left-column-container'
import style from './index.module.scss'

interface ITaskModeProps {
  taskMode: true
  country: string
  centre?: never
  customLinks?: ILink[]
}

interface INormalModeProps {
  taskMode?: false
  Link: LinkType
  centre?: React.ComponentProps<typeof LeftColumnContainer>['centre']
  country: string
  onFindACentre?: () => void
  customLinks?: ILink[]
}

type UniversalFooterProps = ITaskModeProps | INormalModeProps

const commonLinks: ILink[] = [
  { label: 'Careers', href: paths.CAREERS },
  { label: 'Leasing and Media', href: paths.LEASING_MEDIA },
  { label: 'Responsible Business', href: paths.RESPONSIBLE_BUSINESS },
  { label: 'Privacy Policy', href: paths.PRIVACY_POLICY },
  { label: 'Terms and Conditions', href: paths.TERMS_CONDITIONS },
]

const linksNZ = commonLinks
const linksAU: ILink[] = [{ label: 'Products', href: PRODUCTS }, ...commonLinks]

const getChildren = (props: UniversalFooterProps): ReactNode => {
  if (props.taskMode) {
    return null
  }
  const { Link, centre, country, onFindACentre } = props
  return (
    <LinkContext.Provider value={({ ...props }) => <Link {...props} />}>
      <LeftColumnContainer
        centre={centre}
        country={country}
        onFindACentre={onFindACentre}
      />
      <WestfieldPlusContainer country={country} />
    </LinkContext.Provider>
  )
}

export const UniversalFooter = (props: UniversalFooterProps): ReactElement => {
  const newLinksAU = props.customLinks ? props.customLinks : linksAU

  return (
    <div className={style.footerContainer}>
      <SiteFooter
        links={props.country === 'Australia' ? newLinksAU : linksNZ}
        showAngle={false}
      >
        {getChildren(props)}
      </SiteFooter>
    </div>
  )
}
